/* TODO: t() */
import React, { ComponentProps } from 'react';
import { View, Text, StyleSheet } from 'react-native';

import TextInput from './TextInput';

type TextInputProps = ComponentProps<typeof TextInput>;

type Props = Omit<TextInputProps, 'value' | 'onChange'> & {
  value?: string | number;
  onValueChange?: (valueAsNumber: number, valueAsString: string) => void;
  leftIcon?: 'dollar';
  allowNumericCharactersOnly?: boolean;
  min?: number;
};

export default function NumberInput(props: Props) {
  let {
    value,
    onValueChange,
    leftIcon,
    allowNumericCharactersOnly,
    min,
    style,
    ...otherProps
  } = props;
  return (
    <View>
      {leftIcon ? (
        <View style={styles.icon}>
          <Text style={styles.iconText}>$</Text>
        </View>
      ) : null}
      <TextInput
        {...otherProps}
        style={[leftIcon && { paddingLeft: 34 }, style]}
        value={value == null ? undefined : String(value)}
        onChange={(event) => {
          let valueAsString = event.target.value;
          if (allowNumericCharactersOnly) {
            valueAsString = valueAsString.replace(/\D/g, '');
          } else {
            valueAsString = valueAsString.replace(/[^\d\.-]/g, '');
          }
          let valueAsNumber = Number(valueAsString) || 0;
          if (min != null) {
            valueAsNumber = Math.max(valueAsNumber, min);
          }
          onValueChange?.(valueAsNumber, valueAsString);
        }}
      />
    </View>
  );
}

const styles = StyleSheet.create({
  icon: {
    position: 'absolute',
    left: 0,
    top: 0,
    bottom: 0,
    width: 34,
    alignItems: 'center',
    justifyContent: 'center',
  },
  iconText: {
    fontSize: 19,
    color: '#5c7080',
  },
});
